module.exports = {
  defaultTitle: 'Joseph Drane',
  logo: 'https://portfolio.smakosh.com/favicon/favicon-512.png',
  author: 'Joseph Drane',
  url: 'https://josephdrane.com',
  legalName: 'Joseph Drane',
  defaultDescription: 'I’m Joseph and I’m a Network Engineer!',
  socialLinks: {
    github: 'https://github.com/josephdrane',
    linkedin: 'https://www.linkedin.com/in/josephdrane',
  },
  googleAnalyticsID: 'UA-172879949-1',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
    facebook: 'appId',
    twitter: '@josephdrane',
  },
  address: {
    city: 'City',
    region: 'Region',
    country: 'Country',
    zipCode: 'ZipCode',
  },
  contact: {
    email: 'email',
    phone: 'phone number',
  },
  foundingDate: '2020',
};
